module.exports = __webpack_public_path__ + "fonts/Typo_Round_Thin_Demo.64693a1c.otf";